import SeededGrandom from './Grandom/SeededGrandom';
export default new SeededGrandom();
//# sourceMappingURL=index.js.map